import { ComponentType, LazyExoticComponent, Suspense } from 'react';
import Loader from '../../../../../../shared/components/molecules/loader';
import { LOADING } from '../../../../../../shared/constants';
import ProtectedPlaceholder from '../../protected';
import { useProfile } from '../../../../../../shared/hooks/use-profile';

export const ProtectedRoute = ({
  component: LazyComponent,
  hasAccess,
  loading = false,
}: {
  component: LazyExoticComponent<ComponentType<any>>;
  hasAccess: boolean;
  loading?: boolean;
}) => {
  const userDetails = useProfile();

  // Profile not yet loaded or a dependency is still fetching — permissions
  // default to false during loading, so don't flash "Access Denied".
  if (userDetails === undefined || loading) {
    return <Loader size={32} secondary={LOADING} />;
  }

  if (hasAccess) {
    // if (hasAccess && userDetails?.orgId === 'org_w4wEYx0xZ7') {
    return (
      <Suspense fallback={<Loader size={32} secondary={LOADING} />}>
        <LazyComponent />
      </Suspense>
    );
  }

  return <ProtectedPlaceholder />;
};
